// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"47a5ec15","40":"03f5e53f","404":"c97e2040","498":"4c01582b","598":"77ff15e3"}[chunkId] + ".chunk.js";
};